import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useIsAuthenticated } from '@azure/msal-react';

import { PAGE_TYPE } from 'features/order-tracker/services/constants';
import { Block, Title, Form } from 'features/order-tracker/shared-components';
import { pageLoadAnalyticsService } from 'features/order-tracker/store/sagas/services/pageLoadAnalyticsService';
import { getAEMEntryFormProps } from 'features/order-tracker/store/selectors';

import {
  Teaser,
  HeroBanner,
} from './components';
import {
  ANON_FORM_TITLE,
  ANON_FORM_SUB_TITLE,
  AUTH_FORM_TITLE,
  AUTH_FORM_SUB_TITLE,
} from './constants';

import styles from './styles.module.scss';

export function EntryPage(): React.ReactElement {
  const isAuthenticated = useIsAuthenticated();
  const {
    anonymousTitle = ANON_FORM_TITLE,
    authorizedTitle = AUTH_FORM_TITLE,
    anonymousSubtitle = ANON_FORM_SUB_TITLE,
    authorizedSubtitle = AUTH_FORM_SUB_TITLE,
  } = useSelector(getAEMEntryFormProps) || {};
  const formTitle = isAuthenticated ? authorizedTitle : anonymousTitle;
  const formSubTitle = isAuthenticated ? authorizedSubtitle : anonymousSubtitle;

  useEffect(() => {
    pageLoadAnalyticsService.trackPageLoad(PAGE_TYPE.entryPage, isAuthenticated);
  });

  return (
    <>
      <HeroBanner />
      <div className={styles.entryPageHolder}>
        <div className={styles.container}>
          <Block
            headerComponent={<Title title={formTitle} subTitle={formSubTitle} />}
            contentComponent={<Form hasPredefinedValues />}
            isContentUnderlined={false}
          />
        </div>
      </div>
      <Teaser />
    </>
  );
}
